import logo from "assets/images/logo-dxg-no-bg.svg"; // DXG logo
import NotificationDropdown from "components/CommonForBoth/TopbarDropdown/NotificationDropdown/NotificationDropdown";
import ProfileMenu from "components/CommonForBoth/TopbarDropdown/ProfileMenu/ProfileMenu";
import PropTypes from "prop-types";
import React, { useState } from "react";
import "react-drawer/lib/react-drawer.css";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { showRightSidebarAction, toggleLeftmenu } from "store/actions";
import LandingPageDrawer from "views/LandingPageView/LandingPageDrawer/LandingPageDrawer";
import Navbar from "../Navbar/Navbar";
import AppsDropdown from "../../CommonForBoth/TopbarDropdown/AppsDropdown/AppsDropdown";
import { listApp } from "./list-app";
import "./Header.scss";
import { Dropdown, DropdownMenu, DropdownToggle } from "reactstrap";
import { Button } from "react3l-ui-library";
import { SendAlt16 } from "@carbon/icons-react";

const Header = (props: any) => {
  const [isSearch, setSearch] = useState(false);

  const [isShowDrawer, setIsShowDrawer] = React.useState<boolean>(false);
  const [showD, setShowD] = React.useState<boolean>(false);

  const handleClickLandingPage = React.useCallback(() => {
    window.location.href = `/landing-page/`;
  }, []);

  const user = JSON.parse(localStorage.getItem("currentUserInfo"));
  const s3CompanyLogoUrl = `${process.env.REACT_APP_LOGO_WEB}/${user?.businessArea?.code}.png`;
  const handleError = (event: any) => {
    const img = event.target;

    img.src = logo;

    img.alt = "Image failed to load";
  };

  const [siteDrop, setSiteDrop] = React.useState(false);
  const handleToggerSite = React.useCallback(() => {
    setSiteDrop(!siteDrop);
  }, [siteDrop]);

  const handleMouseLeaveAll = React.useCallback(() => {
    setSiteDrop(false);
  }, []);

  const handleClickApp = React.useCallback((link: string) => {
    window.open(link, "_blank");
  }, []);

  function renderAppItem() {
    const list: any[] = [];
    listApp.forEach((app, index) => {
      list.push(
        <>
          <div
            className="box-item-nav"
            key={index}
            onClick={() => handleClickApp(app.linkApp)}
          >
            <div className="app-title">{app.appName}</div>
            <div className="box-image">
              <img src={app?.src} alt={app.appName} width={80} height={80} />
            </div>
          </div>
          <div className="dropdown-divider"></div>
        </>
      );
    });

    return <div>{list}</div>;
  }

  return (
    <React.Fragment>
      <header id="page-topbar">
        <div className="navbar-header">
          <div className="d-flex navbar-header--inner align-items-center">
            <div className="d-flex h-100 align-items-center">
              <div
                className="navbar-brand-box"
                onClick={handleClickLandingPage}
              >
                <Link to={"/"} className="logo logo-dark">
                  <span className="logo-sm">
                    <img
                      src={s3CompanyLogoUrl}
                      alt=""
                      height="32"
                      onError={handleError}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={s3CompanyLogoUrl}
                      alt=""
                      height="32"
                      onError={handleError}
                    />
                  </span>
                </Link>

                <Link to={"/"} className="logo logo-light">
                  <span className="logo-sm">
                    <img
                      src={s3CompanyLogoUrl}
                      alt=""
                      height="32"
                      onError={handleError}
                    />
                  </span>
                  <span className="logo-lg">
                    <img
                      src={s3CompanyLogoUrl}
                      alt=""
                      height="32"
                      onError={handleError}
                    />
                  </span>
                </Link>
              </div>
            </div>
            <button
              type="button"
              className="btn btn-sm px-3 font-size-16 d-lg-none header-item"
              data-toggle="collapse"
              onClick={() => {
                props.toggleLeftmenu(!props.leftMenu);
              }}
              data-target="#topnav-menu-content"
            >
              <i className="fa fa-fw fa-bars" />
            </button>
            <div className="navbar-menu navbar-menu--sm">
              <Navbar />
            </div>
          </div>

          <div className="d-flex navbar-header--inner align-items-center">
            <div className="dropdown d-inline-block d-lg-none ms-2">
              <button
                type="button"
                className="btn header-item noti-icon "
                id="page-header-search-dropdown"
                onClick={() => setSearch(!isSearch)}
              >
                <i className="mdi mdi-magnify" />
              </button>
              <div
                className={
                  isSearch
                    ? "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0 show"
                    : "dropdown-menu dropdown-menu-lg dropdown-menu-end p-0"
                }
                aria-labelledby="page-header-search-dropdown"
              >
                <form className="p-3">
                  <div className="form-group m-0">
                    <div className="input-group">
                      <input
                        type="text"
                        className="form-control"
                        placeholder={props.t("Search") + "..."}
                        aria-label="Recipient's username"
                      />
                      <div className="input-group-append">
                        <button className="btn btn-primary" type="submit">
                          <i className="mdi mdi-magnify" />
                        </button>
                      </div>
                    </div>
                  </div>
                </form>
              </div>
            </div>

            <AppsDropdown />

            <NotificationDropdown />
            <Dropdown
              isOpen={siteDrop}
              toggle={handleToggerSite}
              className={"dxg-dropdown"}
            >
              <DropdownToggle
                id="page-header-user-dropdown"
                className="btn"
                tag="button"
                style={{ boxShadow: "none" }}
              >
                <div className="btn-switch-subsystem">
                  <Button
                    type="secondary"
                    className="btn--lg btn-orange-export"
                    icon={<SendAlt16 />}
                  >
                    Chuyển phân hệ
                  </Button>
                </div>
              </DropdownToggle>
              <DropdownMenu
                className={`dropdown-menu-end p-l--xxs dropdown__list-item`}
              >
                <div className="">
                  <div
                    className={`${siteDrop ? "active" : ""}`}
                    onMouseLeave={handleMouseLeaveAll}
                  >
                    {renderAppItem()}
                  </div>
                </div>
              </DropdownMenu>
            </Dropdown>

            <ProfileMenu />
          </div>
        </div>
      </header>
      <LandingPageDrawer
        isShowDrawer={isShowDrawer}
        setIsShowDrawer={setIsShowDrawer}
        displayDrawer={showD}
        setDisplayDrawer={setShowD}
      />
    </React.Fragment>
  );
};

Header.propTypes = {
  leftMenu: PropTypes.any,
  showRightSidebar: PropTypes.any,
  showRightSidebarAction: PropTypes.func,
  t: PropTypes.any,
  toggleLeftmenu: PropTypes.func,
};

const mapStatetoProps = (state: any) => {
  const { layoutType, showRightSidebar, leftMenu } = state.Layout;
  return { layoutType, showRightSidebar, leftMenu };
};

export default connect(mapStatetoProps, {
  showRightSidebarAction,
  toggleLeftmenu,
})(withTranslation()(Header));
